import { HighlightText } from '@/components/common/HighlightText';
import { CODE_BADGE_CLASS } from '@/styles/codeBadge';
import { TABLE_HEADER_CLASS } from '@/styles/dataTableBg';
import type { AppVersionMember } from '../types/appVersionCheck.types';

interface AppVersionMemberTableProps {
  members: AppVersionMember[];
  searchText?: string | undefined;
}

const formatLastLogin = (value: Date | null): string =>
  value === null ? '—' : value.toLocaleString();

export function AppVersionMemberTable({ members, searchText }: AppVersionMemberTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className={TABLE_HEADER_CLASS}>
          <tr className="text-left text-xs-plus">
            <th className="px-3 py-2 font-medium">Name</th>
            <th className="px-3 py-2 font-medium">HR ID</th>
            <th className="px-3 py-2 font-medium">Mobile</th>
            <th className="px-3 py-2 font-medium">Division</th>
            <th className="px-3 py-2 font-medium">District</th>
            <th className="px-3 py-2 font-medium">Thana</th>
            <th className="px-3 py-2 font-medium">App Version</th>
            <th className="px-3 py-2 font-medium">Last Login</th>
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member.userId} className="border-b last:border-0">
              <td className="px-3 py-2 font-medium">
                <HighlightText text={member.name} highlightedText={searchText} />
              </td>
              <td className="px-3 py-2">
                {member.hrEmpId ? (
                  <HighlightText text={member.hrEmpId} highlightedText={searchText} />
                ) : (
                  '—'
                )}
              </td>
              <td className="px-3 py-2">
                {member.mobile ? (
                  <HighlightText text={member.mobile} highlightedText={searchText} />
                ) : (
                  '—'
                )}
              </td>
              <td className="px-3 py-2">{member.divisionName ?? '—'}</td>
              <td className="px-3 py-2">{member.districtName ?? '—'}</td>
              <td className="px-3 py-2">{member.thanaName ?? '—'}</td>
              <td className="px-3 py-2">
                <span className={CODE_BADGE_CLASS}>{member.appVersion ?? '—'}</span>
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-muted-foreground">
                {formatLastLogin(member.lastLoginTime)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
